<template>
  <div class="fqa-modal" @click="hideFqaModal">
    <div class="bg"></div>
    <button class="close" @click="hideFqaModal">&nbsp;</button>
    <div class="modal-body">
      <h3>{{ this.$t('fqa') }}</h3>
      <div class="content" v-html="this.$t('fqa_content')"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FqaModal",
  props: ["showFqa"],
  data: function() {
    return {};
  },
  computed: {

  },
  methods: {
    hideFqaModal: function() {
      this.$emit("hideFqaModal");
    },
  },
  created: function() {},
};
</script>

<style lang="scss">
@import "../assets/style.scss";
.fqa-modal {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: grid;
  place-items: center;
  .bg {
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.9);
    position: fixed;
  }
  .modal-body {
    max-width: 500px;
    z-index: 10;
    width: 100%;
    .content {
      text-align: left;
      padding: 1rem 1rem;
      line-height: 1.4rem;
      width: 100%;
      ul {
        list-style: none;
        padding-left: 0;
        li {
          color: #e2e2e2;
          font-size: 0.8rem;
          strong { font-size: 1rem; display: block; padding-bottom: 0.4rem; color: #fff; }
          line-height: 1.5rem;
          padding-bottom: 2rem;
        }
      }
    }
  }
}
</style>
